import { COLLECTION_NAME } from ".";
import { useUser, useLibrary } from "contexts";
import { UserRoles } from "data/roles";
import { updateDocument } from "db/mutations";
import { useState } from "react";

/**
 * Hook para alternar el estado de publicación de una historia.
 * @param {string} storyId - ID de la historia a modificar.
 * @returns {function} - Función para alternar el estado de publicación.
 */
export const useTogglePublic = (storyId, is_public) => {
  const [isPublic, setPublic] = useState(is_public);
  const [loading, setLoading] = useState(false);
  const { updateStory } = useLibrary();
  const { hasRole } = useUser();

  const togglePublic = async () => {
    if (!storyId || !hasRole(UserRoles.ADMIN)) return;

    setLoading(true);

    await updateDocument(COLLECTION_NAME, storyId, {
      is_public: !isPublic,
    });

    updateStory(storyId, { isPublic: !isPublic });
    setPublic(!isPublic);
    setLoading(false);
  };

  return { isPublic, loading, togglePublic };
};
